import { CellContainer } from "../CellContainer";
import { CellTextProps } from "./types";
import { StyledText } from "./styles";

export const CellText = ({
  value,
  align = 'start',
  direction,
  gap,
  color,
  fontWeight,
  textAlign,
}: CellTextProps) => {
  const isEmpty = value == null || value === '';

  return (
    <CellContainer
      align={align}
      direction={direction}
      gap={gap}
    >
      <StyledText
        color={color}
        fontWeight={fontWeight}
        textAlign={textAlign}
        className={isEmpty ? 'empty' : ''}
      >
        {isEmpty ? '-' : value}
      </StyledText>
    </CellContainer>
  );
};

CellText.displayName = "CellText";
